"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelatedCoverHeadsUpBannerWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_services_1 = require("@ferry/journey-services");
var core_1 = require("@athena-portal/core");
var journey_model_1 = require("@athena-portal/journey-model");
var commonFunctions_1 = require("../../commonFunctions");
var moment = require("moment");
var portal_core_1 = require("@ferry/portal-core");
var RelatedCoverHeadsUpBannerWidget = /** @class */ (function (_super) {
    __extends(RelatedCoverHeadsUpBannerWidget, _super);
    function RelatedCoverHeadsUpBannerWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            relatedInteraction: null
        };
        return _this;
    }
    RelatedCoverHeadsUpBannerWidget.prototype.componentDidMount = function () {
        var _this = this;
        var relatedProduct = this.props.interaction.product === journey_services_1.ProductsEnum.WOLF_MOTOR ? journey_services_1.ProductsEnum.DRIVE_AWAY : journey_services_1.ProductsEnum.WOLF_MOTOR;
        var relatedInteractionId = this.props.interaction.product === journey_services_1.ProductsEnum.WOLF_MOTOR ?
            this.props.interaction.driveAwayInteractionId : this.props.interaction.annualCoverInteractionId;
        this.propositionEngine.fetchInteractionByEmailAndDob(relatedProduct, relatedInteractionId, this.props.interaction.policyHolder.email, this.props.interaction.policyHolder.dateOfBirth).subscribe(function (relatedInteraction) {
            _this.setState({ relatedInteraction: relatedInteraction });
        });
    };
    RelatedCoverHeadsUpBannerWidget.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f;
        var productName = this.getSetting("productName");
        var coverName = this.getSetting("coverName");
        var vehicle = (_b = (_a = this.state.relatedInteraction) === null || _a === void 0 ? void 0 : _a.vehicles) === null || _b === void 0 ? void 0 : _b[0];
        var make = vehicle === null || vehicle === void 0 ? void 0 : vehicle.make;
        var model = vehicle === null || vehicle === void 0 ? void 0 : vehicle.shortenedModel;
        var registrationNumber = vehicle === null || vehicle === void 0 ? void 0 : vehicle.registrationNumber;
        var product = (_c = this.state.relatedInteraction) === null || _c === void 0 ? void 0 : _c.product;
        var relatedInteractionId = this.props.interaction.product === journey_services_1.ProductsEnum.WOLF_MOTOR ? this.props.interaction.driveAwayInteractionId : this.props.interaction.annualCoverInteractionId;
        var relatedCoverCancellationInitUrl = "/journey/init/product/" + product + "/process/mtc/presetPage/" + relatedInteractionId;
        var isStatusOfRelatedInteractionAgreement = ((_d = this.state.relatedInteraction) === null || _d === void 0 ? void 0 : _d.status) === "AGREEMENT";
        var isRelatedCoverInForceNow = this.isRelatedCoverInForceNow();
        var isRelatedCoverStartingInFuture = this.isRelatedCoverStartingInFuture();
        var relatedCoverStartDate = (_f = (_e = this.state.relatedInteraction) === null || _e === void 0 ? void 0 : _e.headerInfo) === null || _f === void 0 ? void 0 : _f.startDate;
        if (isStatusOfRelatedInteractionAgreement && (isRelatedCoverInForceNow || isRelatedCoverStartingInFuture)) {
            return ((0, jsx_runtime_1.jsx)(portal_core_1.InfoBanner, { wording: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("b", { children: [isRelatedCoverInForceNow &&
                                    (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Heads up - your ", productName + " ", " for your ", make + " " + model + " (" + registrationNumber + ") ", " is still active."] }), isRelatedCoverStartingInFuture &&
                                    (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Heads up - your ", productName + " ", " for your ", make + " " + model + " (" + registrationNumber + ") ", "is due to start on ", (0, commonFunctions_1.formatDate)(relatedCoverStartDate, "DD MMMM YYYY"), "."] })] }), " If you no longer need the ", coverName + " ", " you can cancel it ", " ", " ", (0, jsx_runtime_1.jsx)("a", { href: relatedCoverCancellationInitUrl, children: "here" }), "."] }) }));
        }
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
    RelatedCoverHeadsUpBannerWidget.prototype.isRelatedCoverStartingInFuture = function () {
        var _a, _b;
        var startDate = moment.utc((_b = (_a = this.state.relatedInteraction) === null || _a === void 0 ? void 0 : _a.headerInfo) === null || _b === void 0 ? void 0 : _b.startDate);
        var today = moment().utc();
        return startDate.isAfter(today);
    };
    RelatedCoverHeadsUpBannerWidget.prototype.isRelatedCoverInForceNow = function () {
        var _a, _b, _c, _d;
        var startDate = moment.utc((_b = (_a = this.state.relatedInteraction) === null || _a === void 0 ? void 0 : _a.headerInfo) === null || _b === void 0 ? void 0 : _b.startDate);
        var endDate = moment.utc((_d = (_c = this.state.relatedInteraction) === null || _c === void 0 ? void 0 : _c.headerInfo) === null || _d === void 0 ? void 0 : _d.endDate);
        var today = moment().utc();
        return today.isBetween(startDate, endDate);
    };
    __decorate([
        (0, core_1.lazyInject)(journey_services_1.Types.FalconPropositionEngine),
        __metadata("design:type", Object)
    ], RelatedCoverHeadsUpBannerWidget.prototype, "propositionEngine", void 0);
    RelatedCoverHeadsUpBannerWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "productName", type: journey_model_1.TypeDescriptions.String },
            { name: "coverName", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], RelatedCoverHeadsUpBannerWidget);
    return RelatedCoverHeadsUpBannerWidget;
}(plugin_journey_1.WidgetBase));
exports.RelatedCoverHeadsUpBannerWidget = RelatedCoverHeadsUpBannerWidget;
//# sourceMappingURL=RelatedCoverHeadsUpBannerWidget.js.map